import React from 'react';

import svgInfo from './svgInfo';
import { Vehicle } from './elements';

type Props = {
  readonly className?: string;
  readonly translateImageUrl: string;
  readonly backgroundColor?: string;
  readonly vehicle: string;
  readonly from: string;
  readonly to: string;
};

const travelPath =
  'M264,89.9C250.66,73.08,232.23,62.68,211.89,62.68C191.55,62.68,173.12,73.09,159.79,89.9C146.46,106.71,128.02,117.12,107.68,117.12C87.34,117.12,68.91,106.71,55.58,89.9';

export default function TransportSVG({
  className,
  translateImageUrl,
  backgroundColor,
  vehicle,
  from,
  to,
}: Props): React.ReactElement {
  return (
    <svg
      className={className}
      viewBox="0 0 320 180"
      style={{ background: backgroundColor }}
      role="img"
    >
      <path
        d={travelPath}
        stroke="#ffecb2"
        fill="none"
        strokeWidth="6"
        strokeDasharray="6"
      />
      <Vehicle
        xlinkHref={`${translateImageUrl}transport/vehicles/${vehicle}.svg`}
        width={svgInfo[vehicle].width}
        height={svgInfo[vehicle].height}
        transform={svgInfo[vehicle].transform}
        preserveAspectRatio="none"
        path={travelPath}
      />
      <image
        xlinkHref={`${translateImageUrl}transport/locations/${from}.svg`}
        width="80"
        height="80"
        preserveAspectRatio="none"
        transform="translate(20 50)"
      />
      <image
        xlinkHref={`${translateImageUrl}transport/locations/${to}.svg`}
        width="80"
        height="80"
        preserveAspectRatio="none"
        transform="translate(220 50)"
      />
    </svg>
  );
}
